/**
 * @module views\dynamic\treePage
 */
import Vue from "vue";
import Component from "vue-class-component";
import GhBase from "../../../components/ghBase";
import { TreeNode } from "element-ui/types/tree";
import { Watch } from "vue-property-decorator";
import GhBusinessTree from "@/components/ghBusinessTree/ghBusinessTree";
import GhTablePage from "@/components/ghTablePage/ghTablePage";

@Component
export default class TreePage extends GhBase {
  private args = { parent_id: "", keyword: "" };
  private tabs: IGhTab[] = [{ title: "层级维护", show: true, drawer: true }];
  private parent: TreeNode<string, any> | any = null;
  private cls = "";

  @Watch("parent")
  private observeParent() {
    if (this.parent) {
      if (this.parent.key) {
        this.args.parent_id = this.parent.key;
        let table = this.$refs.table as GhTablePage;
        if (table) {
          table.query(this.args);
        }
      }
    }
  }

  protected onNavigateTo(paras) {
    if (paras && paras.args) {
      let args = eval("(" + paras.args + ")");
      let sourceId = args.sourceId;
      if (sourceId) {
        this.cls = sourceId;
      }
    }
  }

  private beforeSave(item) {
    if (this.parent) {
      item.ParentId = this.parent.key;
    }
  }
}
